import axios, { AxiosResponse } from 'axios'
import { axiosGet } from '../../shared/utils/apiUtils'
import { Project } from './types'

export type ProjectsResponse = Project[]
export type UpdateProjectBody = Pick<Project, 'files'>

const getProjects = (): Promise<ProjectsResponse> =>
  axiosGet('v1/user/projects')

async function updateProject(
  id: string,
  body: UpdateProjectBody
): Promise<Project> {
  const res = await axios.put<UpdateProjectBody, AxiosResponse<Project>>(
    `v1/user/projects/${id}`,
    body
  )
  return res.data
}

async function markAsFavorite(id: string): Promise<Project> {
  const res = await axios.put<Record<string, unknown>, AxiosResponse<Project>>(
    `v1/user/projects/${id}/favorite`,
    {}
  )
  return res.data
}

async function unmarkAsFavorite(id: string): Promise<Project> {
  const res = await axios.delete<
    Record<string, unknown>,
    AxiosResponse<Project>
  >(`v1/user/projects/${id}/favorite`, {})
  return res.data
}

export { getProjects, markAsFavorite, unmarkAsFavorite, updateProject }
